import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var ScreenshotStatus;
(function (ScreenshotStatus) {
    ScreenshotStatus["NEW"] = "NEW";
    ScreenshotStatus["PENDING"] = "PENDING";
    ScreenshotStatus["APPROVED"] = "APPROVED";
    ScreenshotStatus["DECLINED"] = "DECLINED";
    ScreenshotStatus["HIDDEN"] = "HIDDEN";
})(ScreenshotStatus || (ScreenshotStatus = {}));
export var CreativeStatus;
(function (CreativeStatus) {
    CreativeStatus["DRAFT"] = "DRAFT";
    CreativeStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    CreativeStatus["APPROVED"] = "APPROVED";
    CreativeStatus["REJECTED"] = "REJECTED";
    CreativeStatus["SUSPENDED"] = "SUSPENDED";
    CreativeStatus["ARCHIVED"] = "ARCHIVED";
})(CreativeStatus || (CreativeStatus = {}));
export var CreativeType;
(function (CreativeType) {
    CreativeType["NATIVE"] = "NATIVE";
    CreativeType["NATIVE_VIDEO"] = "NATIVE_VIDEO";
})(CreativeType || (CreativeType = {}));
export var ImageType;
(function (ImageType) {
    ImageType["NATIVE16X9"] = "NATIVE16X9";
    ImageType["NATIVE1X1"] = "NATIVE1X1";
})(ImageType || (ImageType = {}));
export var Product;
(function (Product) {
    Product["YALEO_NATIVE_ADD"] = "YALEO_NATIVE_ADD";
    Product["YALEO_INTERACTIVE_STORIES"] = "YALEO_INTERACTIVE_STORIES";
    Product["YALEO_VIDEO_ADD"] = "YALEO_VIDEO_ADD";
})(Product || (Product = {}));
export var Goal;
(function (Goal) {
    Goal["AWARENESS_VIEWABILITY"] = "AWARENESS_VIEWABILITY";
    Goal["INTEREST_TRAFFIC"] = "INTEREST_TRAFFIC";
    Goal["DESIGN_TRAFFIC"] = "DESIGN_TRAFFIC";
    Goal["ENGAGEMENT"] = "ENGAGEMENT";
    Goal["LEADS"] = "LEADS";
    Goal["DIRECT_SALES"] = "DIRECT_SALES";
})(Goal || (Goal = {}));
export var BillingType;
(function (BillingType) {
    BillingType["CPC"] = "CPC";
    BillingType["CPM"] = "CPM";
})(BillingType || (BillingType = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["EN"] = "EN";
    LanguageCode["DE"] = "DE";
    LanguageCode["FR"] = "FR";
    LanguageCode["IT"] = "IT";
})(LanguageCode || (LanguageCode = {}));
export var EventCategory;
(function (EventCategory) {
    EventCategory["NO_CATEGORY"] = "NO_CATEGORY";
    EventCategory["LANDING_PAGE"] = "LANDING_PAGE";
    EventCategory["ITEM_VIEW"] = "ITEM_VIEW";
    EventCategory["ADD_TO_CART"] = "ADD_TO_CART";
    EventCategory["INITIATE_CHECKOUT"] = "INITIATE_CHECKOUT";
    EventCategory["ADD_PAYMENT_INFO"] = "ADD_PAYMENT_INFO";
    EventCategory["PURCHASE"] = "PURCHASE";
    EventCategory["LEAD"] = "LEAD";
})(EventCategory || (EventCategory = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["HYBRID_VIEW_CLICK"] = "HYBRID_VIEW_CLICK";
    TriggerType["VIEW"] = "VIEW";
    TriggerType["CLICK"] = "CLICK";
})(TriggerType || (TriggerType = {}));
export var IntervalType;
(function (IntervalType) {
    IntervalType["DAYS"] = "DAYS";
    IntervalType["HOURS"] = "HOURS";
    IntervalType["MINUTES"] = "MINUTES";
})(IntervalType || (IntervalType = {}));
export var RepeatConversions;
(function (RepeatConversions) {
    RepeatConversions["ONE_CONVERSION_PER_USER"] = "ONE_CONVERSION_PER_USER";
    RepeatConversions["ALL_CONVERSIONS_PER_USER"] = "ALL_CONVERSIONS_PER_USER";
    RepeatConversions["ONE_CONVERSION_PER_USER_EVERY"] = "ONE_CONVERSION_PER_USER_EVERY";
})(RepeatConversions || (RepeatConversions = {}));
export var PixelType;
(function (PixelType) {
    PixelType["IMAGE"] = "IMAGE";
    PixelType["JAVASCRIPT"] = "JAVASCRIPT";
})(PixelType || (PixelType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["BILLING_ADDRESS"] = "BILLING_ADDRESS";
})(PaymentMethod || (PaymentMethod = {}));
export var HistoryType;
(function (HistoryType) {
    HistoryType["CREATE"] = "CREATE";
    HistoryType["UPDATE"] = "UPDATE";
})(HistoryType || (HistoryType = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["INACTIVE"] = "INACTIVE";
    CampaignStatus["ACTIVE"] = "ACTIVE";
    CampaignStatus["ARCHIVED"] = "ARCHIVED";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignFlag;
(function (CampaignFlag) {
    CampaignFlag["PAYMENT_FAILED"] = "PAYMENT_FAILED";
})(CampaignFlag || (CampaignFlag = {}));
export var CampaignPositionStatus;
(function (CampaignPositionStatus) {
    CampaignPositionStatus["INACTIVE"] = "INACTIVE";
    CampaignPositionStatus["ACTIVE"] = "ACTIVE";
    CampaignPositionStatus["EXPIRED"] = "EXPIRED";
    CampaignPositionStatus["RUNNING"] = "RUNNING";
})(CampaignPositionStatus || (CampaignPositionStatus = {}));
export var AdvertiserStatus;
(function (AdvertiserStatus) {
    AdvertiserStatus["INACTIVE"] = "INACTIVE";
    AdvertiserStatus["ACTIVE"] = "ACTIVE";
    AdvertiserStatus["ADMIN"] = "ADMIN";
})(AdvertiserStatus || (AdvertiserStatus = {}));
export var Flag;
(function (Flag) {
    Flag["MISSING_CREATIVES"] = "MISSING_CREATIVES";
    Flag["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    Flag["REJECTED"] = "REJECTED";
    Flag["CREATIVE_INACTIVE"] = "CREATIVE_INACTIVE";
    Flag["PAYMENT_UNSUCCESSFUL"] = "PAYMENT_UNSUCCESSFUL";
    Flag["MISSING_VALID_PAYMENT_METHOD"] = "MISSING_VALID_PAYMENT_METHOD";
})(Flag || (Flag = {}));
export var DocumentEntityType;
(function (DocumentEntityType) {
    DocumentEntityType["ACCOUNT"] = "ACCOUNT";
    DocumentEntityType["CAMPAIGN"] = "CAMPAIGN";
})(DocumentEntityType || (DocumentEntityType = {}));
export var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["ORDER"] = "ORDER";
    DocumentCategory["OFFER"] = "OFFER";
    DocumentCategory["CONFIRMATION"] = "CONFIRMATION";
    DocumentCategory["INVOICE"] = "INVOICE";
    DocumentCategory["CONTRACT"] = "CONTRACT";
    DocumentCategory["REPORT"] = "REPORT";
    DocumentCategory["OTHER"] = "OTHER";
})(DocumentCategory || (DocumentCategory = {}));
export var PayoutStatusDto;
(function (PayoutStatusDto) {
    PayoutStatusDto["PAID"] = "PAID";
    PayoutStatusDto["PENDING"] = "PENDING";
    PayoutStatusDto["IN_TRANSIT"] = "IN_TRANSIT";
    PayoutStatusDto["CANCELED"] = "CANCELED";
    PayoutStatusDto["FAILED"] = "FAILED";
})(PayoutStatusDto || (PayoutStatusDto = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["AUTHORIZATION"] = "AUTHORIZATION";
    PaymentType["CAPTURE"] = "CAPTURE";
})(PaymentType || (PaymentType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["SUCCESSFUL"] = "SUCCESSFUL";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["REQUIRES_CAPTURE"] = "REQUIRES_CAPTURE";
})(PaymentStatus || (PaymentStatus = {}));
